import CostTierForm, { CostTierUpdate } from 'components/shared/highCostMeds/CostTierForm';
import useInvalidateQueries from 'hooks/useInvalidateQueries';
import useMutateWithToast from 'hooks/useMutateWithToast';
import { HighCostMedicationList } from 'models/HighCostMedicationList';
import { updateAdminHighCostMedicationList } from 'services/api/admin/highCostMedicationLists';
import { useToastActions } from 'stores/toastStore';

export type HighCostMedTierFormProps = {
  highCostMedicationList: HighCostMedicationList;
  onClose: () => void;
};

// The admin half of Edit Cost Tiers: the form itself is shared with the customer page, so all that
// lives here is which endpoint a save goes to and what it invalidates afterwards.
export default function HighCostMedTierForm({ highCostMedicationList, onClose }: HighCostMedTierFormProps) {
  const invalidateQueries = useInvalidateQueries();
  const { addToast } = useToastActions();

  const { mutate, isPending } = useMutateWithToast({
    mutationFn: (tiers: CostTierUpdate[]) =>
      updateAdminHighCostMedicationList({ id: highCostMedicationList.id, tiers }),
  });

  const handleSave = (tiers: CostTierUpdate[]) =>
    mutate(tiers, {
      onSuccess: () => {
        // Both queries: the list row carries the tier key the tooltip renders, and the medication
        // table's Cost Tier column sorts on position, so a reorder re-sorts the rows behind this form.
        invalidateQueries({ adminHighCostMedicationLists: true, adminHighCostMedicationListItems: true });
        addToast({ text: 'Cost tiers successfully updated' });
        onClose();
      },
    });

  return (
    <CostTierForm
      tiers={highCostMedicationList.tiers ?? []}
      isSaving={isPending}
      onSave={handleSave}
      onCancel={onClose}
    />
  );
}
